import { render, staticRenderFns } from "./CommentIcon.vue?vue&type=template&id=15b8ee83"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b8ee83')) {
      api.createRecord('15b8ee83', component.options)
    } else {
      api.reload('15b8ee83', component.options)
    }
    module.hot.accept("./CommentIcon.vue?vue&type=template&id=15b8ee83", function () {
      api.rerender('15b8ee83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CommentIcon.vue"
export default component.exports